import CenteredContent from '@picsart/rc/old/CenteredContent';
import classnames from 'classnames';

import useStyles from './styles';

function ImageSliderWithCTAFallback({ categories, photoTemplatesData, videoTemplatesData }: any) {
  const styles = useStyles();
  const data = videoTemplatesData || photoTemplatesData;
  const cards = 4;

  return (
    <CenteredContent>
      <div className={styles.skeletonRoot} data-testid="ImageSliderWithCTAFallback-skeleton">
        <div className={styles.skeletonTitle}>
          <i className="skeleton" />
        </div>
        <div className={styles.skeletonDesc}>
          <i className="skeleton" />
        </div>
        {!!categories?.length && (
          <div className={styles.toggleButton}>
            <i className="skeleton" />
          </div>
        )}
        <div className={styles.skeletonGrid}>
          {[...Array(cards)].map((_, index) => (
            <div
              className={classnames(data?.length > 4 ? styles.gridSmall : styles.grid)}
              key={`${index}`}
            >
              <i className="skeleton" />
            </div>
          ))}
        </div>
        <div className={styles.skeletonButton}>
          <i className="skeleton" />
        </div>
      </div>
    </CenteredContent>
  );
}

export default ImageSliderWithCTAFallback;
